'use client';

import { useEffect, useState } from 'react';
import { Menu, MenuButton, MenuItems } from '@headlessui/react';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from 'react-share';
import { Share } from 'components/gruenland/icons/Share';

const SharePicker: React.FC<{
  text?: string;
}> = ({ text }) => {
  const [currentUrl, setCurrentUrl] = useState('');
  useEffect(() => {
    setCurrentUrl(
      window.document.querySelector("link[rel='canonical']")?.getAttribute('href') || window.location.toString(),
    );
  }, []);

  return (
    <Menu as="div" className="relative">
      <>
        <MenuButton className="flex size-[64px] items-center justify-center rounded-full ring-2 ring-inset ring-black">
          <Share width={22} />
        </MenuButton>

        <MenuItems
          transition
          modal={false}
          className="mt-[10px] flex gap-3 text-center transition ease-out data-[closed]:scale-95 data-[closed]:opacity-0 lg:absolute lg:inset-x-0 lg:top-[10px] lg:translate-y-[64px] lg:flex-col"
        >
          <FacebookShareButton url={currentUrl} title={text} aria-label="Condividi su Facebook">
            <FacebookIcon size={64} round bgStyle={{ fill: '#303330' }} />
          </FacebookShareButton>
          <LinkedinShareButton url={currentUrl} title={text} aria-label="Condividi su LinkedIn">
            <LinkedinIcon size={64} round bgStyle={{ fill: '#303330' }} />
          </LinkedinShareButton>
          <TwitterShareButton url={currentUrl} aria-label="Condividi su X">
            <XIcon size={64} round bgStyle={{ fill: '#303330' }} />
          </TwitterShareButton>
          <WhatsappShareButton url={currentUrl} aria-label="Condividi su Whatsapp">
            <WhatsappIcon size={64} round bgStyle={{ fill: '#303330' }} />
          </WhatsappShareButton>
          <EmailShareButton url={currentUrl} aria-label="Condividi via email">
            <EmailIcon size={64} round bgStyle={{ fill: '#303330' }} />
          </EmailShareButton>
        </MenuItems>
      </>
    </Menu>
  );
};

export default SharePicker;
